import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContent from "~/components/CommonContent";
import { mapState } from "vuex";
import PageTitle from "~/components/PageTitle";

export default {
  components: {
    CommonContent: CommonContent,
    PageTitle: PageTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageData", { id: "4", lang: query.lang });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", { pageData: result });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {

      idx: 0,
      idxs: null
    };
  },

  methods: {
    toggle: function toggle(index) {
      this.idx = index;
      if (this.idxs === index) {
        this.idxs = null;
      } else {
        this.idxs = index;
      }
    }
  },
  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    descPageData: function descPageData() {
      var _this = this;

      return this.pageData.map(function (val, key) {
        return _this.pageData[_this.pageData.length - 1 - key];
      });
    },
    requ: function requ() {
      return this.descPageData[this.idx].content.split('\n');
    },
    pro: function pro() {
      if (this.lang === 'en') {
        return 'Requirements:';
      } else {
        return '要求:';
      }
    },
    proe: function proe() {
      if (this.lang === 'en') {
        return 'Details';
      } else {
        return '详情';
      }
    },
    pros: function pros() {
      if (this.lang === 'en') {
        return 'Job offers';
      } else {
        return '招聘职位';
      }
    },
    pageName: function pageName() {
      if (this.lang === 'en') {
        return 'Join us!';
      } else {
        return '欢迎加入东丽 !';
      }
    },
    intro: function intro() {
      if (this.lang === 'en') {
        return 'Dongli Garden, strives to be a beauty discover and creator, by overcoming one challenge after another. Our team has many years of experience in garden design and landscaping, bringing together a large number of professionals in the field, both home and abroad.';
      } else {
        return '东丽园林，秉承“发现美，创造美” 的理念，不断提升、超越，接受挑战，我们的团队拥有多年的园林造景经历，汇聚了中外园林造景领域众多的综合人才。';
      }
    }
  })

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/join.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/join.vue
// module chunks = 6